import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import firebaseApp from '../../../src/firebase.js';
import { post } from "../../utils/fetch"

const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

export const createUser = async () => {
  const api = `/create-user`;
  return await post(api).catch(err => {
    throw err;
  });
};

export const getUser = async () => {
  const api = `/user/get`;
  return await post(api)
    .then(res => res.data.user)
    .catch(() => null);
};

export const signInWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  const user = result.user;
  const token = await user.getIdToken();

  localStorage.setItem('accessToken', token);
  localStorage.setItem('email', user.email);

  // Set up token refresh
  auth.onIdTokenChanged(async user => {
    if (user) {
      const newToken = await user.getIdToken();
      localStorage.setItem('accessToken', newToken);
    }
  });

  return await createUser();
};

export const signInWithEmail = async (email, password, redirectUrl) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;
  const token = await user.getIdToken();

  localStorage.setItem('accessToken', token);
  localStorage.setItem('email', user.email);

  auth.onIdTokenChanged(async user => {
    if (user) {
      const newToken = await user.getIdToken();
      localStorage.setItem('accessToken', newToken);
    }
  });

  window.location.href = redirectUrl;
};

export const registerWithEmail = async (email, password) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;
  const token = await user.getIdToken();

  localStorage.setItem('accessToken', token);
  localStorage.setItem('email', user.email);

  auth.onIdTokenChanged(async user => {
    if (user) {
      const newToken = await user.getIdToken();
      localStorage.setItem('accessToken', newToken);
    }
  });

  await createUser();
};
